import { createStyledClone } from '@/services/print/svghelpers';


// import defaultChart from './PDFBaseChart';
/* eslint-disable no-param-reassign */
export default (metric, options) => {
    const chartFont = { size: 'sm' };
    const dotPlot = ({ label, svg, value, font }) => ({
        font: chartFont,
        mt: 2,
        valueLabel: {
            // border: { colour: '#ff0000' },
            w: 'w-1-7/8',
            text: label,
            font
        },
        dotPlotSvg: {
            display: 'inline',
            // border: { colour: '#0000ff' },
            // h: 'h-0-1/4',
            w: 'w-2-1/8',
            // x: 'w-1-5/8',
            dotPlot: {
                // y: 2,
                svg: createStyledClone({ svg }),
                w: 'w-1-3/4'
            },
            text: metric.formatWithUnits(value),
            // w: 'w-4',
            align: 'right',
            font
        },
        // value: {
        //     display: 'inline',
        //     text: metric.formatWithUnits(value),
        //     // w: 'w-4',
        //     // align: 'right',
        //     font
        // }
    });
    // const { definition } = defaultChart(metric, template);
    const { colour, label, definition } = options;
    const selector = `#${metric.id} svg:not(.content-placeholder):not(.svg-inline)`;
    const svgs = document.querySelectorAll(selector);
    const regionCompareChart = {
        label,
        charts: metric.value && {
            // h: 'h-1',
            // border: { colour: '#ffff00' },
            valueChart: dotPlot({
                label: metric.valueLabel,
                svg: svgs[0],
                value: metric.value,
                font: { colour }
            }),
            comparisonChart: dotPlot({
                label: `${metric.comparisonRecord.geographyName}${metric.comparisonGeographyCode === 'AB' ? '' : ' Zone'}`,
                svg: svgs[1],
                value: metric.comparisonValue
            })
        },
        noData: !metric.value && {
            dataUnavailable: {
                text: `Data Unavailable for ${metric.valueLabelFull}`,
                font: { colour, size: 'sm' }
            },
            zoneChart: dotPlot({
                label: `${metric.zoneRecord.geographyName} Zone`,
                svg: svgs[0],
                value: metric.zoneValue
            }),
            abChart: dotPlot({
                label: metric.abRecord.geographyName,
                svg: svgs[1],
                value: metric.abValue
            })
        },
        bestChart: metric.bestRecord && dotPlot({
            label: `Best ${metric.bestLabel}`,
            svg: svgs[2],
            value: metric.bestValue,
        }),
        subLabel: metric.bestRecord && {
            font: { colour: 'print.primary.7', size: 'sm', style: 'italic' },
            text: `${metric.bestRecord.geographyName} LGA`,
            mb: 'h-0-1/16'
        },
        definition
    };
    return regionCompareChart;
};
